import { useIntercom } from "react-use-intercom";
import PageTitle from "@/Shared/Layout/PageTitle";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Link } from "@freightsimple/ui-core/Typography/Link";
import { T } from "@freightsimple/ui-core/Typography/T";

const SUPPORT_EMAIL = "support@freightsimple.com";

// Shown when quoting is unavailable for the account — either turned off
// manually by our team, or the account is on hold (ENG-5862). We deliberately
// do NOT offer the manual/dedicated quoting flow here — funneling these
// customers into manual quoting creates ops work with no context (see
// ENG-5439). Instead we explain the situation and give a one-click way to
// reach support.
export function BookShipmentQuotingDisabled() {
  const showNewMessage = useIntercom().showNewMessage;

  return (
    <>
      <PageTitle>Quoting unavailable</PageTitle>
      <div className="flex flex-col items-center">
        <h2 className="text-2xl font-bold text-foreground">
          Quoting is currently unavailable for your account
        </h2>
        <div className="h-[16px]" />
        <T size="base" color="secondary">
          Please get in touch with our customer support team and we&apos;ll be
          happy to help you with your shipment.
        </T>
        <div className="h-[24px]" />
        <Button
          onClick={() =>
            showNewMessage(
              "Hi, quoting is unavailable on my account. Can you help?",
            )
          }
        >
          Chat with support
        </Button>
        <div className="h-[12px]" />
        <T size="base" color="secondary">
          or email <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>
        </T>
      </div>
    </>
  );
}
